const refreshSecondCarousel = ({ praType, articleId, styleWithArticles }) => {
    if (praType === 'SWG') {
        const pra1Element = document.getElementById('product-reco-pra1');
        if (pra1Element) {
            pra1Element.props = Object.assign(Object.assign(Object.assign(Object.assign({}, pra1Element.props), { refreshcarousel: true }), (articleId && { articleid: articleId })), (styleWithArticles && { stylewitharticles: styleWithArticles }));
        }
    }
};
const shouldWaitForDataLoad = (praConfiguration) => {
    const { ID, BRAND } = praConfiguration;
    if (ID === 'PRA1' && BRAND === 'hm') {
        const swgElementExists = document.getElementById('product-reco-swg');
        return !!swgElementExists;
    }
    return false;
};
const attachColorSwatchListeners = (stateSetter) => {
    // moving event here to cut dependency to mr cycle
    const colorSwatches = document.querySelectorAll('button[data-articlecode], li[data-articlecode]');
    if (colorSwatches.length > 1) {
        colorSwatches.forEach((swatchElement) => {
            swatchElement.addEventListener('click', (event) => {
                const { currentTarget } = event;
                if (currentTarget && currentTarget instanceof HTMLElement) {
                    stateSetter(currentTarget.dataset.articlecode || null);
                }
            });
        });
    }
};
const getStyleWithDefaultsForVariant = (articleId) => {
    // Relies on productArticleDetails in PDP source, if not found returns null.
    let articles = null;
    if (articleId && window.productArticleDetails) {
        const { styleWithDefaultArticles } = window.productArticleDetails[articleId] || {};
        if (!styleWithDefaultArticles) {
            const { styleWithArticles } = window.productArticleDetails[articleId] || {};
            if (styleWithArticles === null || styleWithArticles === void 0 ? void 0 : styleWithArticles.length) {
                articles = styleWithArticles.map((article) => article.code).join(',');
            }
        }
        else {
            articles = styleWithDefaultArticles;
        }
    }
    return articles;
};
export { refreshSecondCarousel, attachColorSwatchListeners, shouldWaitForDataLoad, getStyleWithDefaultsForVariant, };
//# sourceMappingURL=pdp.js.map